import { useState } from 'react'

import { AdminEndOfferingWizard } from '../components'

const AdminEndOffering = () => {
  const [showWizard, setShowWizard] = useState(false)

  const handleEndCurrentOffering = () => {
    setShowWizard(true)
  }

  const handleCancelOffering = () => {
    setShowWizard(false)
  }

  // Show wizard
  if (showWizard) {
    return (
      <div className="flex flex-1">
        <AdminEndOfferingWizard cancelOffering={handleCancelOffering} />
      </div>
    )
  }

  return (
    <>
      <p>
        If you're ready to END the current offering of TMC and reset all program
        data, you've come to the right place!
      </p>
      <p className="font-bold text-flame">
        Upon clicking the button below, you will be guided through a simple 2
        step process to END the current TMC offering:
      </p>
      <p>
        <strong>Step 1&#41; Download a TMC Report:</strong> This is your
        opportunity to download the offering data before it's erased. The report
        provides various insights, including attendance data and items completed
        in the Learning Lounge per participant.
      </p>
      <p>
        <strong>Step 2&#41; Confirm platform reset:</strong> Confirm that you
        wish to proceed with the platform reset and erase all offering data.
      </p>
      <p>To start this process, click the button below.</p>
      <div className="mx-auto mt-4 rounded-[12px] bg-gainsboro px-4 py-3 lg:w-[90%]">
        <span className="font-bold text-[red]">WARNING:</span>{' '}
        <span className="italic">
          The button below will reset the TMC Online Platform in anticipation of
          the next offering. To avoid data loss, only end the current offering
          when you are completely finished using the site.
        </span>
      </div>
      <div className="mt-4 text-center">
        <button
          className="mx-2 mt-4 rounded-full bg-[red] px-6 pb-2 pt-[0.4rem] font-bold text-white transition-colors hover:bg-skin-button-accent-hover active:translate-y-[0.75px] active:scale-[0.99]"
          onClick={handleEndCurrentOffering}
        >
          END CURRENT OFFERING
        </button>
      </div>
    </>
  )
}

export default AdminEndOffering
